import {ColumnDef} from "./types";
import {formatTimestamp} from "../../utils/datetime";

export const defaultColumnDef: Pick<ColumnDef<any>, "align" | "sortable"> = {
    align: "left",
    sortable: true,
};

export const dateTimeColumnDef: Pick<ColumnDef<any>, "align" | "sortable" | "formatCellText"> = {
    ...defaultColumnDef,
    formatCellText: ({cellValue}) => {
        return formatTimestamp(cellValue);
    },
};
